export enum AiConnectProjectType {
  PSL = 'PSL',
  PROVIDER_DIRECTORY = 'provider_directory'
}

export enum AiConnectComponent {
  FIND_MY_FIT = 'find-my-fit',
  CHAT_COMPONENT = 'chat-component'
}
